// Mock data for Datasignz CreativeMinds website

export const heroSlides = [
  {
    id: 1,
    type: "video",
    media: "https://customer-assets.emergentagent.com/job_visual-studio-104/artifacts/t0cu97hu_TBL%20TVC%202025.mp4",
    poster: "https://customer-assets.emergentagent.com/job_5d2b1704-c912-40b5-94d1-19a432268dc7/artifacts/7i2y6b1m_fullscreenvideo.jpg",
    projectName: "TBL Cinemas",
    projectDesc: "Brand identity promo with slogan and short versions for social media",
    nameKey: "heroSlide1Name",
    descKey: "heroSlide1Desc"
  },
  {
    id: 2,
    type: "video",
    media: "https://customer-assets.emergentagent.com/job_visual-studio-104/artifacts/p9gbgz6s_Datasignz_Promo_Video.mp4",
    poster: "https://customer-assets.emergentagent.com/job_5d2b1704-c912-40b5-94d1-19a432268dc7/artifacts/7i2y6b1m_fullscreenvideo.jpg",
    projectName: "Datasignz CreativeMinds Showreel",
    projectDesc: "",
    nameKey: "heroSlide2Name",
    descKey: "heroSlide2Desc"
  },
  {
    id: 3,
    type: "video",
    media: "https://customer-assets.emergentagent.com/job_visual-studio-104/artifacts/ep4fq7ac_AKIRA%20Promo%2066s%20v3_1.mp4",
    poster: "https://customer-assets.emergentagent.com/job_5d2b1704-c912-40b5-94d1-19a432268dc7/artifacts/7i2y6b1m_fullscreenvideo.jpg",
    projectName: "Akira Overwater Resort",
    projectDesc: "Promo video",
    nameKey: "heroSlide3Name",
    descKey: "heroSlide3Desc"
  },
  {
    id: 4,
    type: "video",
    media: "https://customer-assets.emergentagent.com/job_visual-studio-104/artifacts/gfwdfy17_Birdland%20aflevering%206%20-%20Cock%20of%20the%20Rock.mp4",
    poster: "https://customer-assets.emergentagent.com/job_5d2b1704-c912-40b5-94d1-19a432268dc7/artifacts/7i2y6b1m_fullscreenvideo.jpg",
    projectName: "Birdland Suriname",
    projectDesc: "Cock of the Rock",
    nameKey: "heroSlide4Name",
    descKey: "heroSlide4Desc"
  },
  {
    id: 5,
    type: "video",
    media: "https://customer-assets.emergentagent.com/job_visual-studio-104/artifacts/g8nllzyp_How%20the%20Amazon%20became%20a%20safe-haven%20for%20enslaved%20Africans.mp4",
    poster: "https://customer-assets.emergentagent.com/job_5d2b1704-c912-40b5-94d1-19a432268dc7/artifacts/7i2y6b1m_fullscreenvideo.jpg",
    projectName: "BBC documentary",
    projectDesc: "How the Amazon became a safe-haven for enslaved Africans",
    nameKey: "heroSlide5Name",
    descKey: "heroSlide5Desc"
  }
];

export const portfolioImages = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1577190651915-bf62d54d5b36?w=600&q=80",
    title: "Production Setup",
    titleKey: "portfolioProductionSetup"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1639701386739-449a0e789367?w=600&q=80",
    title: "Professional Lighting",
    titleKey: "portfolioProfessionalLighting"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1574446615002-35ec8a8f0da2?w=600&q=80",
    title: "Cinematographer",
    titleKey: "portfolioCinematographer"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1548944588-bd022d6b3a9b?w=600&q=80",
    title: "Camera Setup",
    titleKey: "portfolioCameraSetup"
  },
  {
    id: 5,
    image: "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?w=600",
    title: "Post-Production",
    titleKey: "portfolioPostProduction"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1598703900524-09a0c7defa29?w=600&q=80",
    title: "FX6 Cinema Camera",
    titleKey: "portfolioFX6Camera"
  }
];

export const companyIntro = [
  {
    title: "Creative Media Production",
    content: "Datasignz CreativeMinds is a full-service creative media and digital studio based in Paramaribo, specializing in high-impact visual storytelling and brand-driven communication. We produce professional TV commercials, corporate films, music videos, documentaries, animations, and visual effects for brands, artists, and organizations across diverse industries."
  },
  {
    title: "Digital Solutions",
    content: "Beyond media production, we support businesses with custom websites, e-commerce solutions, domain registration, and hosting—ensuring a strong, reliable online presence. Our work is further strengthened by integrated marketing campaigns, including social media content, email marketing, branding, and AI-powered chatbots that enhance customer engagement and automation."
  },
  {
    title: "Full-Service Partner",
    content: "By combining creativity, technology, and strategy, Datasignz CreativeMinds acts as a single digital partner—helping brands build identity, connect with audiences, and grow across platforms. We are more than just a creative studio; we are your complete solution for visual storytelling and digital transformation."
  }
];

export const services = {
  videoProduction: [
    {
      title: "TV Commercials & Advertising",
      description: "Professional commercials for retail, automotive, hospitality, and corporate clients.",
      pricing: "Starting from USD 750 (30s) – USD 1250 (60s)",
      examples: ["Building Depot", "Japan Motors", "MN International", "Sultan Rental"]
    },
    {
      title: "Corporate Films & Mood Videos",
      description: "Identity-driven productions that highlight company culture, values, and brand promise.",
      pricing: "Mood Videos starting from USD 250 (30s) – USD 450 (60s)",
      examples: ["Brunch Brigade mood video"]
    },
    {
      title: "Music Videos",
      description: "Creative collaborations with artists to bring their vision to life.",
      pricing: "Starting from USD 750",
      examples: ["Fabiola Carmelita", "Prince G.", "Asgar Koster", "Faya Dolo"]
    },
    {
      title: "Documentaries & Short Films",
      description: "Covering cultural, environmental, and social themes with cinematic quality.",
      pricing: "Price on request",
      examples: ["Amazon history", "REDD+ projects", "Climate change awareness"]
    },
    {
      title: "Promo Videos",
      description: "Promotional films for brands, projects, and events.",
      pricing: "Starting from USD 250 (30s) – USD 450 (60s)",
      examples: []
    },
    {
      title: "After Movies / Event Videos",
      description: "Recap videos of events that capture the energy and highlights.",
      pricing: "Starting from USD 250 (30s) – USD 450 (60s)",
      examples: []
    }
  ],
  postProduction: [
    {
      title: "Animations & Visual Effects",
      description: "Motion graphics, 3D animation, dynamic transitions, and cinematic color grading.",
      pricing: "Starting from USD 2500 (30s) – USD 3750 (60s)"
    },
    {
      title: "Color Grading & Post-Production",
      description: "Professional color grading and editing services to enhance your video productions.",
      pricing: "Starting from USD 400 per day"
    },
    {
      title: "SocialVidzz",
      description: "Dynamic animations and social-ready video content with captivating transitions.",
      pricing: "Starting from USD 50 (15s)"
    },
    {
      title: "Video Testimonials",
      description: "Professional testimonial videos featuring up to 3 people.",
      pricing: "USD 100"
    },
    {
      title: "Extra Language Support",
      description: "Add additional language versions to your video content.",
      pricing: "USD 100 per language"
    }
  ],
  marketingBranding: [
    {
      title: "Email Marketing Campaigns",
      description: "Targeted campaigns to build customer relationships, promote products, and drive conversions.",
      features: ["Design", "Automation", "Analytics"]
    },
    {
      title: "Social Media Marketing",
      description: "Engaging content tailored for Facebook, Instagram, TikTok, and LinkedIn.",
      features: ["SocialVidzz animations", "Dynamic transitions", "Attention-grabbing posts"]
    },
    {
      title: "Branding & Brand Development",
      description: "Strategic campaigns built around identity, promise, and uniqueness.",
      clients: ["TBL Cinemas", "SCCN", "Rock Oil", "Rudisa", "DSB Bank", "Fernandes Bottling"]
    },
    {
      title: "AI Bots & Automation",
      description: "AI-powered chatbots for customer support, lead generation, and interactive marketing.",
      pricing: "Customer Service Chat Bot: USD 500"
    }
  ],
  webServices: [
    {
      title: "Landing Page",
      price: "USD 250",
      delivery: "2 days",
      features: ["Basic design", "Responsive layout", "Contact form", "Social media integration", "Photo gallery"]
    },
    {
      title: "Website Budget",
      price: "USD 500",
      delivery: "3 days",
      features: ["Basic design", "Responsive layout", "4 pages", "Contact form", "Social media integration", "Photo gallery", "Bookings form"]
    },
    {
      title: "Website Standard",
      price: "USD 1000",
      delivery: "5 days",
      features: ["Custom design matching branding", "Responsive layout", "Maximum 10 pages", "Contact form", "Social media integration", "Photo gallery & video links", "Booking/Quote form"]
    },
    {
      title: "Website Elite",
      price: "USD 1750",
      delivery: "7 days",
      features: ["Custom design matching branding", "Responsive layout", "Maximum 25 pages", "Contact form", "Social media integration", "Photo gallery & video links", "Booking/Quote form"]
    }
  ],
  webExtras: [
    { name: "Video Header / Animated Header", price: "USD 50" },
    { name: "Search Engine Optimization", price: "USD 50" },
    { name: "Search Function", price: "USD 50" },
    { name: "WhatsApp Chat Integration", price: "USD 50" },
    { name: "Google Analytics", price: "USD 25" },
    { name: "AI Image and Video Generation", price: "USD 50" },
    { name: "E-commerce Solutions", price: "Price upon request" },
    { name: "Domain Registration & Hosting", price: "Price upon request" }
  ]
};

export const sitemapLinks = [
  { name: "Homepage", nameKey: "home", path: "/" },
  { name: "Video Production", nameKey: "videoProduction", path: "/video-production" },
  { name: "Post Production", nameKey: "postProduction", path: "/post-production" },
  { name: "On-Air Identity", nameKey: "onAirIdentity", path: "/on-air-identity" },
  { name: "Marketing & Branding", nameKey: "marketingBranding", path: "/marketing-branding" },
  { name: "Web Services", nameKey: "webServices", path: "/web-services" },
  { name: "Contact", nameKey: "contact", path: "/contact" }
];

export const legalLinks = [
  { name: "Privacy Policy", nameKey: "privacyPolicy", path: "/privacy-policy" },
  { name: "Terms of Service", nameKey: "termsOfService", path: "/terms-of-service" },
  { name: "Cookie Policy", nameKey: "cookiePolicy", path: "/cookie-policy" },
  { name: "Disclaimer", nameKey: "disclaimer", path: "/disclaimer" }
];

export const socialLinks = [
  { name: "Facebook", url: "https://facebook.com/datasignz" },
  { name: "TikTok", url: "https://tiktok.com/@datasignz" },
  { name: "Instagram", url: "https://instagram.com/datasignz" },
  { name: "WhatsApp", url: "https://wa.me/597" }
];

export const contactInfo = {
  email: "brian@datasignz.nl",
  location: {
    address: "Paramaribo, Suriname",
    lat: 5.8232,
    lng: -55.1679
  }
};
